import { getHomeCatalogStatsQueryOptions } from "@/routes/_home/home-query";
const SplitLoader = async ({
  context: {
    queryClient
  }
}) => ({
  stats: await queryClient.ensureQueryData(getHomeCatalogStatsQueryOptions()).catch(() => null)
});
export { SplitLoader as loader };